"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DropdownDivider", {
    enumerable: true,
    get: function() {
        return DropdownDivider;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const DropdownDivider = (props)=>{
    const { colors, spacers } = (0, _Theme.useTheme)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("hr", {
        ...props,
        className: _style.default.dynamic([
            [
                "80500c4bf40e6aab",
                [
                    colors.border,
                    spacers.s3
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "")
    }), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "80500c4bf40e6aab",
        dynamic: [
            colors.border,
            spacers.s3
        ]
    }, "hr.__jsx-style-dynamic-selector{border:none;border-top:1px solid ".concat(colors.border, ";margin:").concat(spacers.s3, " 0}")));
};

//# sourceMappingURL=DropdownDivider.js.map